
let baseUrl='https://cdb.0731app.cn/';
export function handleImg(val){
    if(!val){
        return '';
    }
    if(val&&val.indexOf('http')!=-1){
        return val;
    }else{
        return baseUrl+val;
    }
}
